export class ProgramLevelMapper {
  static transform(programLevels: string[]): string[] {
    return (programLevels || []).slice().map((level) => {
      /* remove 's' from Masters and Bachelors */
      if (level?.substring(level.length - 1, level.length) === 's') {
        return level.substring(0, level.length - 1);
      }

      return level;
    });
  }
}
